module.exports = __webpack_public_path__ + "img/11.d653bdc4.svg";